import Axios from 'axios'
import { API_HOST } from '../utils/constant'

const axios = Axios.create({
    baseURL: API_HOST
})

export default axios